import axios from "@utilities/axios";
import { create } from "zustand";

export interface CountryState {
  idMap: Record<string, string>;
  supportedIso2: string[];
  isLoaded: boolean;

  load: () => Promise<void>;
  getCountryId: (iso2: string) => string;
}

export const useCountryStore = create<CountryState>((set, get) => ({
  idMap: {},
  supportedIso2: [],
  isLoaded: false,

  load: async () => {
    if (get().isLoaded) return;
    try {
      const formData = new FormData();
      formData.append("action", "get-countries-list");
      const response = await axios.post("/my_address/", formData);
      const idMap: Record<string, string> = {};
      const supportedIso2: string[] = [];
      (response.data?.countries as Array<{ id: string; iso2: string }>).forEach(
        c => {
          if (c.iso2) {
            const code = c.iso2.toUpperCase();
            idMap[code] = c.id;
            supportedIso2.push(code);
          }
        },
      );
      set({ idMap, supportedIso2, isLoaded: true });
    } catch {
      // Silent fail
    }
  },

  getCountryId: (iso2: string): string => {
    return get().idMap[iso2.toUpperCase()] ?? iso2;
  },
}));

export const useCountryState = (): CountryState => {
  return useCountryStore(state => {
    return state;
  });
};
